// extracted by mini-css-extract-plugin
module.exports = {"style":"_-6QCHlEjd_nb8mZ53hZ1u"};